import Bookmark from 'src/icons/Bookmark';
import { history } from 'src/utils/history';
import EventService from 'src/services/EventService';
import { ROUTES_URL } from 'src/constants/routes';
import { StarIcon } from 'src/icons/StarIcon';

import { AccordionMenuItem } from './components/AccordionMenu';

const menuList: AccordionMenuItem[] = [];

export const PAGES: AccordionMenuItem[] = [
    {
        title: 'Главная',
        icon: <StarIcon />,
        onClick: () => {
            history.push('/');
            EventService.dispatch('CLOSE_MENU');
        },
    },
];

export default menuList;
